module.exports = __webpack_public_path__ + "img/city.54f2f092.jpg";